/**
 * @return {string}
 */
function OrDefaultFilter(value, defaultOverride) {
  return value || defaultOverride || '—'
}

export default OrDefaultFilter
export { OrDefaultFilter }
